import { render, staticRenderFns } from "./CommentFeed.vue?vue&type=template&id=eb949e44&"
import script from "./CommentFeed.vue?vue&type=script&lang=js&"
export * from "./CommentFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports